import { render, staticRenderFns } from "./peaPrint.vue?vue&type=template&id=84550d28&scoped=true"
import script from "./peaPrint.vue?vue&type=script&lang=js"
export * from "./peaPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84550d28",
  null
  
)

export default component.exports